import { render, staticRenderFns } from "./NewsCategoryWidget.vue?vue&type=template&id=3ba29081&scoped=true"
import script from "./NewsCategoryWidget.vue?vue&type=script&lang=js"
export * from "./NewsCategoryWidget.vue?vue&type=script&lang=js"
import style0 from "./NewsCategoryWidget.vue?vue&type=style&index=0&id=3ba29081&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba29081",
  null
  
)

export default component.exports